<script>
import ProductListPlaceholder from './ProductListPlaceholder.vue';
import BoucingDots from '../kit/BouncingDots.vue';

export default {
  name: 'ProductListLoader',
  components: { ProductListPlaceholder, BoucingDots },
};
</script>

<template>
  <div>
    <div class="flex text-gray-500 mt-2">
      {{ $t('search_in_progress') }}
      <BoucingDots class="ml-1 text-xl" />
    </div>

    <ProductListPlaceholder />
  </div>
</template>
